import type { FaqSectionType } from '../common/types';

export const generalFaqSections = [
    'dataDifferent', 
    'submitFeedback', 
    'townCity', 
    'soManyAds', 
    'ourPolicy', 
    'dataUsed', 
    'notificationServices', 
    'thunderstormAlerts',
    'manageNotificationServices',
    'keepGettingAlerts',
    'lightningALerts',
    'lightningColors',
    'seeRadar',
    'mapColors',
    'weatherIconMeanings'
];

const websiteFaqSections = [
    'changeMeasurements',
    'weatherNews',
    'saveLocation',
    'changeStation',
    'findCameras',
    'airQualitySection',
    'fireSection',
    'sparkSection',
    'coldFlu',
    'recenterMap',
    'changeMapLayer'
];

const androidFaqSections = [
    'changeUnits',
    'zoomInOut',
    'switchLocations',
    'blankObservations',
    'eliteProblems',
    'keepGettingAlerts',
    'enableDisable',
    'reorderFeed',
    'manageLocation',
    'removeAds',
    'findLocations',
    'wrongLocation',
    'unsubscribe',
    'weatherIconMeanings'
];

const iosFaqSections = [
    'turnOffAlerts',
    'reorderFeed',
    'removeAds',
    'manageLocation',
    'keepGettingAlerts',
    'findLocation',
    'changeUnits',
    'wrongLocation',
    'unsubscribe',
    'weatherIconMeanings'
];

const othersFaqSections = [
    'install',
    'managaeLocations',
    'switchLayers',
    'howToWatch',
    'supportedDevices'
];

const accountDeletionFaqSections = [
    'deleteMyAccount'
];

export interface FaqType {
    [key: string]: FaqSectionType;
}

export const faqTypes: FaqType = {
    'faq': {
        type: 'generalFaq',
        pageId: 'faq',
        name: 'general',
        sections: generalFaqSections
    },
    'faq/general': {
        type: 'generalFaq',
        pageId: 'faq',
        name: 'general',
        sections: generalFaqSections
    },
    'faq/website': {
        type: 'websiteFaq',
        pageId: 'faq/website',
        name: 'website',
        sections: websiteFaqSections
    },
    'faq/android': {
        type: 'androidFaq',
        pageId: 'faq/android',
        name: 'android',
        sections: androidFaqSections
    },
    'faq/ios': {
        type: 'iosFaq',
        pageId: 'faq/ios',
        name: 'iOS',
        sections: iosFaqSections
    },
    'faq/others': {
        type: 'othersFaq',
        pageId: 'faq/others',
        name: 'other',
        sections: othersFaqSections
    },
    'faq/accountdeletion': {
        type: 'accountDeletion',
        pageId: 'faq/accountdeletion',
        name: 'Account Deletion',
        sections: accountDeletionFaqSections
    }
};
